import React, {useRef, useEffect} from 'react';
import Slider from 'react-slick';
import { ImageDetail } from '../types';

interface MainSliderProps {
    images: ImageDetail[];
    activeIndex: number;
    setActiveIndex: (index: number) => void;
    gallerySettings: any;
    onImageClick: (index: number) => void;
}

export const MainSlider: React.FC<MainSliderProps> = ({
    images,
    gallerySettings,
    activeIndex,
    setActiveIndex,
    onImageClick
}) => {

    const sliderRef = useRef<Slider>(null);

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(activeIndex, true);
        }
    }, [activeIndex]);

    return(

    <div className='slider slider-for detail-big-car-gallery popup-gallery limit-height-big-photo bg-overlay-black-10'>
        <div className='slick-list draggable'>
            <div className="slick-track">
                <Slider {...gallerySettings} ref={sliderRef} afterChange={(current) => {if (current !== activeIndex) {setActiveIndex(current)}}}>
                    {images.map((img, index) => (
                        <div key={index} className="slick-slide">
                            <a onClick={() => onImageClick(index)} href="javascript:void(0)" className="portfolio-img">
                                <img
                                    className={`img-fluid w-100`}
                                    alt="Slider Image"
                                    src={img.urlBig ?? ''}
                                />
                            </a>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    </div>
    )
};